import script from "./DocumentRowOtherDeposits.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentRowOtherDeposits.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItemSection,QBadge,QList,QItem,QItemLabel});
